import { useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import clientApi from '~/clientApi';
import { Creator } from '~/clientApi/creator.model';
import { CREATOR_PROFILE_QUERY_KEY } from '~/queries/keys';

type UseGetCreatorProfile = {
  slug?: string;
};

export const useGetCreatorProfile = ({ slug }: UseGetCreatorProfile) => {
  return useQuery<Creator, AxiosError>(
    [CREATOR_PROFILE_QUERY_KEY, { slug }],
    () => clientApi.getCreatorProfile({ slug }),
    { enabled: Boolean(slug), staleTime: 1000 * 60 * 5 },
  );
};
